// The portal's translations: messages/<locale>.json, keyed by message id like messages/en.json.
//
// Calls aren't compiled to ids (see ./extracted.ts), so a translator looks a message up by its
// English text: ./catalogLoader.ts pairs a locale's catalog with the English one by id.

/** English message → translation. */
export type Catalog = ReadonlyMap<string, string>;

/** Pairs the English catalog with a locale's, by message id. Untranslated messages stay English. */
export const pairCatalogs = (
  english: Record<string, string>,
  translated: Record<string, string>,
): Catalog => {
  const catalog = new Map<string, string>();
  for (const [id, message] of Object.entries(english)) {
    const translation = translated[id];
    if (translation) catalog.set(message, translation);
  }
  return catalog;
};
